import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutes } from './shared/enums/app-routes.enum';
import { xpoAuthCanMatch } from '@xpo-ltl/ngx-auth';

const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./cost-root/cost-root.component').then((c) => c.CostRootComponent),
    canMatch: [xpoAuthCanMatch()],
    children: [
      {
        path: AppRoutes.MODULE_EXECUTOR_ROUTE,
        loadChildren: () => import('./module-executor/module-executor.module').then((m) => m.ModuleExecutorModule),
      },
      {
        path: AppRoutes.DAG_INPUTS_ROUTE,
        loadChildren: () => import('./dag-input/dag-input.module').then((m) => m.DagInputModule),
      },
      {
        path: AppRoutes.AI_DASHBOARD_ROUTE,
        loadChildren: () => import('./ai-dashboard/ai-dashboard.module').then((m) => m.AiDashboardModule),
      },
      {
        path: '',
        redirectTo: AppRoutes.MODULE_EXECUTOR_ROUTE,
        pathMatch: 'full'
      }
    ]
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
